import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STTPaidUnpaidV1 = _resolveComponent("STTPaidUnpaidV1")!
  const _component_STTPaidUnpaidV2 = _resolveComponent("STTPaidUnpaidV2")!

  return (_ctx.version === 'v1')
    ? (_openBlock(), _createBlock(_component_STTPaidUnpaidV1, { key: 0 }))
    : (_openBlock(), _createBlock(_component_STTPaidUnpaidV2, { key: 1 }))
}